<div style="padding-top: 8px; padding-bottom: 4px">
  <div class="titolo-sezione-dialog">Inserimento Norma</div>
  <div class="descrizione-sezione-dialog" style="color: #424242 !important">
    {{ data.risposta }}
  </div>
</div>

<div style="height: 15px"></div>
<div appFormContainer [larghezza]="2">
  <mat-form-field appFormElement [larghezza]="2">
    <mat-label>Codice Norma</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      placeholder="Codice Norma"
      [(ngModel)]="data.normaRisposta.codiceNormaVsme"
      rows="1"
    ></textarea>
  </mat-form-field>

  <mat-form-field appFormElement [larghezza]="2">
    <mat-label>Descrizione Norma</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      placeholder="Descrizione Norma"
      [(ngModel)]="data.normaRisposta.descrizioneNormaVsme"
      rows="3"
    ></textarea>
  </mat-form-field>
</div>

<div class="cnt-btn">
  <button mat-raised-button color="primary" class="primary-button" (click)="salva()">Salva</button>
</div>
